<template>
  <div class="logo-wrapper" v-if="org">
    <!--org-->
    <img ref="logo" @load="OnLoad" class="logo" :src="org.logo" /><!--org.logo-->
  </div>
</template>

<script>
export default {
  name: 'LogoHeader',
  props: {
    org: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    OnLoad() {
      this.$refs.logo.className = (() => {
        // The numbers correspond to the percent height that the logo takes up within the parent
        // element so that we can adjust the look of it for wide and skinny logos
        if (this.$refs.logo.clientHeight / this.$refs.logo.parentElement.clientHeight < 0.32){
          return 'logo-wide-max'
        }
        else if (this.$refs.logo.clientHeight / this.$refs.logo.parentElement.clientHeight < 0.36){
          return 'logo-wide-80'
        }
        else if(this.$refs.logo.clientHeight / this.$refs.logo.parentElement.clientHeight < 0.4){
          return 'logo-wide-70'
        }
        return 'logo'
      })()
    },
  },
}
</script>
<style lang="scss" scoped>
.logo-wrapper {
  height: 12rem;
  width: 90%;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  max-height: 12rem;
  max-width: 60%;
}

.logo-wide-70 {
  height: auto;
  width: 70%;
}

.logo-wide-80 {
  height: auto;
  width: 80%;
}

.logo-wide-max {
  height: auto;
  width: 100%;
}
</style>